var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF",
      "outlined": "",
      "dense": ""
    },
    on: {
      "paste": function ($event) {
        $event.preventDefault();
        return _vm.validarPegarNumeros.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "cpf", $$v);
      },
      expression: "form.filters.cpf"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Usuário",
      "outlined": "",
      "dense": "",
      "maxlength": "252"
    },
    model: {
      value: _vm.form.filters.nomeCompleto,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nomeCompleto", $$v);
      },
      expression: "form.filters.nomeCompleto"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Perfil",
      "items": _vm.form.lists.listPerfis,
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.perfil,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "perfil", $$v);
      },
      expression: "form.filters.perfil"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 2,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": _vm.buscarUsuarios
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": _vm.resetForm
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterUsuario();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listUsuarios,
      "item-key": "id",
      "footer-props": _vm.$footerProps,
      "sort-by": "nome",
      "show-expand": "",
      "expanded": _vm.expanded,
      "items-per-page": _vm.itemsPerPage,
      "page": _vm.paginaAtual,
      "server-items-length": _vm.totalItens
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      },
      "update:page": [function ($event) {
        _vm.paginaAtual = $event;
      }, _vm.avancarItemsPerPage],
      "update:items-per-page": _vm.atualizarItemsPerPage
    },
    scopedSlots: _vm._u([{
      key: `item.cpf`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "hide-report"
        }, [_vm._v(" " + _vm._s(_vm.$esconderCpf(item.cpf)) + " ")])];
      }
    }, {
      key: `item.nomeCompleto`,
      fn: function (_ref2) {
        var _item$nomeSocial;
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s((_item$nomeSocial = item.nomeSocial) !== null && _item$nomeSocial !== void 0 ? _item$nomeSocial : item.nomeCompleto) + " ")];
      }
    }, {
      key: `item.email`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.email) + " ")];
      }
    }, {
      key: `item.perfis`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.perfis) + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.situacao
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarUsuario(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar",
            "icon": "mdi-pencil",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterUsuario(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.situacao ? 'var(--primary-button-color)' : 'silver'}`,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarUsuario(item);
            }
          }
        })];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref7) {
        var headers = _ref7.headers,
          item = _ref7.item;
        return [_c('td', {
          staticClass: "perfis",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.perfis, function (perfil, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_c('v-icon', {
            staticClass: "perfil",
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account-multiple")]), _vm._v(" " + _vm._s(perfil.nome) + " ")], 1);
        }), 1)], 1)];
      }
    }, {
      key: `item.emUso`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Uso',
            "icon": item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
            "color": item.emUso ? 'green' : 'red',
            "small": true,
            "disabled": !item.emUso
          },
          on: {
            "click": function ($event) {
              item.emUso ? _vm.openDialogDetalharUsoUsuario(item) : null;
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('EditarUsuarioDialog', {
    attrs: {
      "visible": _vm.dialogManterUsuario.visible,
      "content": _vm.dialogManterUsuario.content,
      "edit": _vm.dialogManterUsuario.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterUsuario.close();
      },
      "onSave": function ($event) {
        return _vm.buscarUsuarios();
      }
    }
  }), _c('VisualizarUsuarioDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarUsuario.visible,
      "content": _vm.dialogVisualizarUsuario.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarUsuario.close();
      }
    }
  }), _c('DetalharUsoUsuarioDialog', {
    attrs: {
      "visible": _vm.dialogDetalharUsoUsuario.visible,
      "content": _vm.dialogDetalharUsoUsuario.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogDetalharUsoUsuario.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }